
import grid1 from '../Images/grid1.jpeg'
import grid2 from '../Images/grid2.jpeg'
import grid3 from '../Images/grid3.jpeg'
import grid4 from '../Images/grid4.jpeg'
import grid5 from '../Images/grid5.jpeg'
import grid6 from '../Images/grid6.jpeg'
import grid7 from '../Images/grid7.jpeg'
import grid8 from '../Images/grid8.jpeg'
import img4 from '../Images/slider3.jpeg'
import img5 from '../Images/slider10.jpeg'
import img8 from '../Images/slider4.jpeg'



const data = [
    {
        bgImg: img5 ,
        sect: 'slide',
      
    },
    {
        bgImg: img4 ,
        sect: 'slide',
       
    },
    {
        bgImg: img8 ,
        sect: 'slide',
       
    },
    {   
        bgImg1: grid1,
        bgImg2: grid2,
        header1: 'Built for Tough Roads: Heavy Duty Diesel Engine Oil',
        header2: '',
        bodyText: 'When your diesel engine demands reliability under the toughest conditions, our Heavy Duty Diesel Engine Oil, SAE 50, delivers unmatched protection and durability. Formulated with cutting-edge UAE technology, it keeps your engine performing at its best, even in the harshest environments. Trust Oyoyo diesel engine oil for exceptional performance and peace of mind, ensuring your engine runs smoothly and efficiently, reducing wear and maximizing uptime. Get the strength to go further with Oyoyo.',
        sect: 'heroSlider',
        btnText: 'equip your engine for the long haul'
    }, 
    {
        
        bgImg1: grid3,
        bgImg2: grid4,
        header1: 'Unleash Peak Performance with My Gold Super No.1 Motor Oil',
        header2: '',
        bodyText: 'Experience the ultimate in engine protection and performance with our premium My Gold Super No.1 Motor Oil, SAE 50. Designed for high-performance vehicles, this UAE-formulated lubricant ensures your engine runs smoother, stronger, and longer. This full synthetic oil reduces wear, helps combat sludge, and provides long engine life and protection for critical engine parts in a wide variety of temperatures and driving conditions. Ready to drive like never before? Trust in My Gold for the protection and performance your engine needs.',
        sect: 'heroSlider',
        btnText: 'Discover the power of my gold super No. 1'
    },
    {
        
        bgImg1: grid5,
        bgImg2: grid6,
        header1: 'Revitalize Your Engine with Super Tonic Engine Oil',
        header2: "",
        bodyText: "Give your engine the tonic it needs with our Super Tonic Engine Oil, SAE 20W/50. Designed for versatility and superior protection, this UAE-formulated lubricant adapts to a wide range of engines, ensuring optimal performance in every condition. Tested in the lab, on the road, and in the toughest conditions, Super Tonic provides exceptional wear protection, cleaning power, and overall performance to keep your engine running smoothly.",
        sect: 'heroSlider',
        btnText: 'Try super tonic for unmatched versatility'
    },
    {
        
        bgImg1: grid7,
        bgImg2: grid8,
        header1: 'Premium Performance with Oyoyo ATF DEXRON III D',
        header2: "",
        bodyText: "Experience unparalleled transmission performance with Oyoyo ATF DEXRON III D. Specially formulated in the UAE, this advanced automatic transmission fluid is designed to meet the demanding requirements of modern transmissions. It provides exceptional protection against wear, and ensures smooth shifting in all driving conditions.",
        sect: 'heroSlider',
        top: 'object-top',
        btnText: 'Transform your driving experience today'

    },
   
    
    
]

export default data